<template>
    <naj-modal ref="showDocumentsModel"
               :width="1500"
               :footer="true"
               :close-button="true"
               :show-footer-close-button="true"
               @onClose="closeShowDocumentsModel">
        <v-row>
            <v-col cols="2">
                <template v-for="(doc ,index) in documents">
                    <div :key="index"
                         :class="['row my-5 header-text document-entry py-2',{'outlined':doc.id == (selectedDocument||{}).id}]"
                         @click="getDocument(index)">
                        <div class="py-1 text-c-green col-6">
                            {{ local.caseFile.cards.document.attachmentName }}
                        </div>
                        <div class="py-1 text-info-value col-6">
                            {{ doc.attachmentName }}
                        </div>

                        <div class="py-1 text-c-green col-6">
                            {{ local.caseFile.cards.document.typeDisplayName }}
                        </div>
                        <div class="py-1 text-info-value col-6">
                            {{ doc.documentType }}
                        </div>
                        <template v-if="doc.createDate">
                            <div class="py-1 text-c-green col-6">
                                {{ local.caseFile.cards.document.dateDisplayName }}
                            </div>
                            <div class="py-1 text-info-value col-6">
                                {{ toHijriDate( doc.createDate) }}
                            </div>
                        </template>
                    </div>
                </template>
            </v-col>

            <v-col cols="10">
                <div class="preview-holder">
                    <pdf-document-viewer :document="document"
                                         :loading="loading"
                                         :has-pdf-document="!!selectedDocument.spid"
                                         :file-name="documentFileName"
                                         :download-button-text="local.caseFile.cards.document.downloadDocument"
                                         :auto-download-on-mobile="true"
                                         @downloaded="onDocumentDownloaded" />
                </div>
            </v-col>
        </v-row>

        <template slot="actions"
                  slot-scope="{ closeNajModal }" />
    </naj-modal>
</template>

<script>
    import PdfDocumentViewer from '../components/file-viewer/pdf-document-viewer.vue';
    import { createNamespacedHelpers } from 'vuex';
    const { mapActions: mapCaseActions } = createNamespacedHelpers('CasesModule');
    import { toHijriDate } from '@/helpers/utils';

    export default {
        name: 'ShowDocumentsModel',
        components: {
            PdfDocumentViewer,
        },
        props: {
            documents: {
                type: Array,
                required: true,
            },
            modalVisibility: {
                type: Boolean,
                required: true,
            },
            selectedDocumentIndexProp: {
                type: Number,
                required: false,
                default: 0,
            },
        },
        data() {
            return {
                loading: false,
                document: null,
                selectedDocumentIndex: this.selectedDocumentIndexProp,
            };
        },
        computed: {
            selectedDocument() {
                return ((this.documents || [])[this.selectedDocumentIndex]) || {};
            },
            documentFileName() {
                const attachmentName = this.selectedDocument.attachmentName || 'document';
                return `${attachmentName}.pdf`;
            },
        },
        methods: {
            ...mapCaseActions(['getTrustedSourceAttachment']),
            toHijriDate,
            closeShowDocumentsModel() {
                this.resetData();
                this.$emit('modalClose');
            },
            resetData() {
                this.document = null;
                this.loading = false;
            },
            getDocument(index) {

                this.selectedDocumentIndex = index;

                this.loading = true;
                this.getTrustedSourceAttachment(this.selectedDocument.spid)
                    .then((attachment) => {
                        this.document = `data:application/pdf;base64,${attachment}`;
                    })
                    .finally(
                        () => (this.loading = false)
                    );
            },
            onDocumentDownloaded(fileName) {
                // Handle document downloaded event if needed
                console.log('Document downloaded:', fileName);
            },
        },
        watch: {
            modalVisibility(newValue) {
                if (newValue) {
                    this.$refs.showDocumentsModel.show();
                    this.getDocument(this.selectedDocumentIndexProp);
                } else {
                    this.$refs.showDocumentsModel.close();
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .preview-holder {
        display: block !important;
        height: 600px;
        width: 100%;
    }

    .document-entry {
        border: 2px solid #a2a2a2;
        border-radius: 5px;
        cursor: pointer;

        &.outlined {
            border: 4px solid #1fb9b8;
        }

        .text-info-value {
            font-size: 14px;
            font-weight: bold;
        }
    }
</style>